import { Component, Inject, PLATFORM_ID, Renderer2, ElementRef, HostListener } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Settings, AppSettings } from './app.settings';
import { isPlatformBrowser } from '@angular/common';
import { ApiService } from './shared/services/api.service';
import { CookieService } from 'ngx-cookie-service';
import { SubscriptionService } from './shared/services/subscription.service';
import { WindowService } from './shared/services/window.service';
import * as CryptoJS from 'crypto-js';
import { GoogleAnalyticsService } from './theme/utils/google-analytics';
import { storeLinksType } from './types/sign-in';
import { FeatureTags, FeatureTagObject } from './types/feature-tags';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from './shared/services/sharedata.service';

// import AOS from 'aos';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

})
export class AppComponent {
  isServer = true;
  loading: boolean = false;
  public settings: Settings;
  storeDetails = {};
  paymentOption = [];
  storeDetailsJson = {};
  featureTags: FeatureTags[] = []
  windowRef;
  isLoading:boolean = false
  private destroy$ = new Subject<void>();

  constructor(public appSettings: AppSettings, public router: Router, private activatedRoute: ActivatedRoute,
    private subscription: SubscriptionService, private windowService: WindowService, private readonly renderer: Renderer2,
    private readonly el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object, private cookieService: CookieService,
    private apiService: ApiService,public sharedDataService: SharedDataService) {

    this.settings = this.appSettings.settings;
    if (isPlatformBrowser(this.platformId)) {
      this.isLoading = true;
    }
    if (this.settings['gaTrackingShow'] === 'yes') {
      GoogleAnalyticsService.loadGoogleAnalytics(this.settings.gaTrackingID);
      // this is the snippet which make google analytics able to track page view load as i mentioned above in the introduction

      this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (isPlatformBrowser(this.platformId)) {
            (window as any).ga('set', 'page', event.urlAfterRedirects);
            (window as any).ga('send', 'pageview');
          }

        }
      }
      );
    }
    if (isPlatformBrowser(this.platformId) && this.settings['gaTrackingShow'] === 'yes') {
      this.loadGoogleAnalyticsSSR();
    }


  }


  ngOnInit() {
    // AOS.init();
    // {once: true, disable: true} 
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));  
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.isServer = false;
      })
    }
    this.apiService.getStoreDetails()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {
        if (!!result['response']['data']['payment_method_details']) {
          this.paymentOption = result['response']['data']['payment_method_details'];
          if(this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']){
          this.sharedDataService.paymentDetails = this.paymentOption;
          }
          var cardEnable = this.paymentOption.find(method => method.name === 'authorize_net' ||  method.name === 'stripe') !== undefined;
        }
        sessionStorage.setItem('cardEnable', cardEnable ? "true" : "false");
        if (!!result['response']['data']['store']) {
          this.storeDetails = result['response']['data']['store'];
          this.storeDetailsJson = result['response']['data']['store_json'];
          // save store details in session start
          if (isPlatformBrowser(this.platformId)) {
            this.setStoreValues();
          } else {
            this.setStoreValues();
          }
        }
        this.settings['name'] = this.storeDetailsJson['settings']['siteTitle'];
        if (!!this.storeDetailsJson['settings']['theme']) {
          this.settings['theme'] = this.storeDetailsJson['settings']['theme'];
        }

      }
    }, (error) => {
      if (error) {
        console.log(error);
      }
    });
    if (!!this.cookieService.get('rememberMe')) {
      const rememberMe = JSON.parse(this.cookieService.get('rememberMe'));
      if (!!rememberMe) {
        rememberMe['password'] = CryptoJS.AES.decrypt(rememberMe['password'], 'hjgefbugigc47567869vbl489235785678yn64').toString(CryptoJS.enc.Utf8),
          this.apiService.customerLogin(rememberMe)
          .pipe(takeUntil(this.destroy$))
          .subscribe(res => {
            if (res['response']['status'] === 1) {
              localStorage.setItem('token', res['response']['data'].token);
              this.apiService.setLogin({
                loggedIn: true,
                userDetails: res['response']['data'].user_details
              });
              if (res['response']['data']['cut_off_details']['delivery_date'] !== null) {
                var cutOffTime = [{
                  storeCutOffTime: res['response']['data']['cut_off_details']['store_date_time']['date'],
                  currentDateAndtime: res['response']['data']['cut_off_details']['current_date_time']['date'],
                  orderDeliveryDate: res['response']['data']['cut_off_details']['delivery_date'],
                  storeDeliveryDate: res['response']['data']['cut_off_details']['store_delivery_date'],
                  deliveryDay: res['response']['data'].user_details['delivery_day'],
                  orderStatus: res['response']['data']['cut_off_details']['order_status'],
                  orderPresent: res['response']['data']['cut_off_details']['order']
                }];
                sessionStorage.setItem('cutoff', JSON.stringify(cutOffTime));
                sessionStorage.setItem('selected_delivery_date', res['response']['data']['cut_off_details']['delivery_date']);
                this.subscription.subjectNext({ msg: "get shopping cart status bar data" });
              }
            }
          });
        this.subscription.subjectNext({ loginwithRememberMe: true });
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    this.router.events
    .pipe(takeUntil(this.destroy$))
    .subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      }
    })
  }

  setStoreValues() {
    sessionStorage.removeItem('storeLinks');
    sessionStorage.removeItem('storeStatus');
    sessionStorage.setItem('store', JSON.stringify({
      id: this.storeDetails['id'],
      name: this.storeDetails['name'],
      logo: this.storeDetails['logo'],
      address: this.storeDetails['address'],
      phone: this.storeDetails['phone'],
      currency: this.storeDetails['currency'],
      site_maintenance: this.storeDetails['site_maintenance'],
      cart_without_registration: this.storeDetails['cart_without_registration'],
      cc_collection_point: this.storeDetails['cc_collection_point'],
      delivery_address_input_preference: this.storeDetails['delivery_address_input_preference'],
      automatic_route_assignment: this.storeDetails['automatic_route_assignment'],
      waitlist_for_non_service_areas: this.storeDetails['waitlist_for_non_service_areas'],
      delivery_fee: this.storeDetails['delivery_fee'],
      fulfillment_options: this.storeDetails['fulfillment_options'],
      delivery_upper_limit: this.storeDetails['delivery_upper_limit'],
      rate_per_bottle: this.storeDetails['rate_per_bottle'],
      date_format: this.storeDetails['date_format'],
      time_zone: this.storeDetails['time_zone'],
      cart: this.storeDetails['cart_without_registration'],
      order_cut_off_day: this.storeDetails['order_cut_off_day'],
      order_cut_off_time: this.storeDetails['order_cut_off_time'],
      siteTitle: this.storeDetailsJson['settings']['siteTitlePrefix'],
      minimum_order_value: this.storeDetails['minimum_order_value']
      // is_redirect_to_primary: this.storeDetails['is_redirect_to_primary']
    }));
    let fullphone = this.storeDetails['phone'];
    var x = fullphone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    fullphone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

    sessionStorage.setItem('stphone', fullphone);
    sessionStorage.setItem('stemail', this.storeDetails['reply_to_email']);
    sessionStorage.setItem('storeLinks', JSON.stringify(this.storeDetailsJson["links"]));
    sessionStorage.setItem('storeStatus', JSON.stringify(this.storeDetails["mode"]));
    this.subscription.setCartWithoutRegistrationStatus(this.storeDetails['cart_without_registration'])
  }
  loadGoogleAnalyticsSSR() {
    const script = this.renderer.createElement('script') as HTMLScriptElement;
    script.src = `//www.googletagmanager.com/gtag/js?id=${this.settings['gaTrackingID']}`;
    script.async = true;
    this.renderer.appendChild(this.el.nativeElement, script);

    const script2 = this.renderer.createElement('script') as HTMLScriptElement;
    const scriptBody = this.renderer.createText(`
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag('js', new Date());

        gtag('config', '${this.settings['gaTrackingID']}');
      `);
    this.renderer.appendChild(script2, scriptBody);
    this.renderer.appendChild(this.el.nativeElement, script2);

    const script3 = this.renderer.createElement('script') as HTMLScriptElement;
    const scriptBody3 = this.renderer.createText(`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '221627108267352');
            fbq('track', 'PageView');
        `);
    this.renderer.appendChild(script3, scriptBody3);
    this.renderer.appendChild(this.el.nativeElement, script3);


    const script4 = this.renderer.createElement('noscript') as HTMLScriptElement;
    const scriptBody4 = this.renderer.createText(`
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=221627108267352&ev=PageView&noscript=1"
          />
        `);
    this.renderer.appendChild(script4, scriptBody4);
    this.renderer.appendChild(this.el.nativeElement, script4);
  }

  
  updateLink(id: string, href: string) {
    const link: HTMLLinkElement = document.getElementById(id) as HTMLLinkElement;
    if (link) {
      link.href = `${href}?v=${new Date().getTime()}`; // Avoid caching issues
    } else {
      console.warn(`Link with id ${id} not found.`);
    }
  }
  
  
  

}
